<template>
  <transition name="modal" appear>
    <div class="modal modal-overlay" @click.self="$emit('close')">
      <div class="modal-window">
        <div class="modal-content">
          <section class="list-box white-box row">
            <h2 class="modal-title">ユーザー情報編集</h2>
            <form>
              <table class="register-table">
                <tr>
                  <th>メールアドレス</th>
                  <td>
                    <input type="text" v-model="tempUser.email" name="email">
                    <div v-if="invalid" class="text-error util-line-height-none"><small>入力されたメールアドレスは登録されています。</small></div>
                    <div v-else-if="submitted && !$v.tempUser.email.required" class="text-error util-line-height-none"><small>メールアドレスを入力してください。</small></div>
                    <div v-else-if="submitted && !$v.tempUser.email.email" class="text-error util-line-height-none"><small>メールアドレスのフォーマットに誤りがあります。</small></div>
                  </td>
                </tr>
                <tr>
                  <th>氏名</th>
                  <td>
                    <input type="text" v-model="tempUser.name" name="name">
                    <div v-if="submitted && !$v.tempUser.name.required" class="text-error util-line-height-none"><small>お名前を入力してください。</small>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>性別</th>
                  <td>
                    <label><input type="radio" v-model="tempUser.gender" name="sex" value="0">男性</label>
                    <label><input type="radio" v-model="tempUser.gender" name="sex" value="1">女性</label>
                    <label><input type="radio" v-model="tempUser.gender" name="sex" value="2">無回答</label>
                  </td>
                </tr>
                <tr>
                  <th>部署名</th>
                  <td>
                    <input type="text" v-model="tempUser.department" name="department" placeholder="※ない場合は「なしと入力してください」">
                    <div v-if="submitted && !$v.tempUser.department.required" class="text-error util-line-height-none"><small>部署名を入力してください。</small></div>
                  </td>
                </tr>
                <tr>
                  <th>役職</th>
                  <td>
                    <input type="text" v-model="tempUser.position" name="position" placeholder="※ない場合は「なしと入力してください」">
                    <div v-if="submitted && !$v.tempUser.position.required" class="text-error util-line-height-none"><small>役職を入力してください。</small></div>
                  </td>
                </tr>
              </table>
              <div class="modal-btn">
                <span class="btn-gray2"><button @click.prevent="$emit('close')">キャンセル</button></span>
                <span class="btn-gray2"><button @click.prevent="editBtnClick()">編集する</button></span>
              </div>
            </form>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import httpResource from '../http/httpResource'
import store from '../store/index'
import {required, email} from 'vuelidate/lib/validators'
import Processing from '../util/processing'

export default {
  mixins: [Processing],
  props: ['user'],
  data () {
    return {
      submitted: false,
      invalid: false,
      tempUser: {...this.user}
    }
  },
  methods: {
    async editBtnClick () {
      this.submitted = true
      this.invalid = false
      // stop here if form is invalid
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      const userEditForm = {
        id: this.tempUser.id,
        email: this.tempUser.email,
        name: this.tempUser.name,
        gender: this.tempUser.gender,
        department: this.tempUser.department,
        position: this.tempUser.position
      }
      try {
        const response = await httpResource.post('/corporation/users/edit', userEditForm, {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          if (response.data.message !== 'INVALID') {
            this.$emit('reloadData')
            this.$emit('close')
          } else {
            this.invalid = true
          }
        }
      } catch (error) {
        console.log(error.response.data)
      }
      setTimeout(function () {
        // ボタンのロックを解除する
        this.endProcessing()
      }.bind(this), 2000)
    }
  },
  validations: {
    tempUser: {
      email: {
        required,
        email
      },
      name: {
        required
      },
      department: {
        required
      },
      position: {
        required
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EditUser.vue